// extracted by mini-css-extract-plugin
export default {"content":"Request_content__UsHL8","isSubPage":"Request_isSubPage__F9JkT"};